const navToggler = document.getElementById('navtoggler');
const navContainer = document.getElementById('mainnav-holder');
const navCloser = document.getElementById('navcloser');
const childNavCloser = document.getElementById('childnav-closer');
const largeBeacon = document.getElementById('lg-beacon');
const navWrapper = document.getElementById('navwrapper');

function initMobileNavBun() {
    navToggler.addEventListener('click', (e) => {
        e.preventDefault();
        navContainer.classList.toggle('active');
        navToggler.classList.toggle('is-active');
    });
}

function initNavCloser() {
    navCloser.addEventListener('click', (e) => {
        e.preventDefault();
        navContainer.classList.remove('active');
        navToggler.classList.remove('is-active');
    })
}

function initMobileNavChildren() {
    const childNavOpeners = document.querySelectorAll('button.child-nav-opener');
    let openNavStack = [];

    childNavOpeners.forEach(childNavOpener => {
        childNavOpener.addEventListener('click', (e) => {
           e.preventDefault();
            let targetNavID = childNavOpener.getAttribute('aria-controls');
            let targetNav = document.getElementById(targetNavID);
            if (targetNav) {
                targetNav.classList.add('visible');
                navCloser.classList.remove('visible');
                childNavCloser.classList.add('visible');
                openNavStack.push(targetNavID);
            }
        });
    });

    childNavCloser.addEventListener('click', (e) => {
        e.preventDefault();
        let targetNavID = openNavStack.pop();
        let targetNav = document.getElementById(targetNavID);
        if (targetNav) {
            targetNav.classList.remove('visible');
        }

        if (openNavStack.length === 0) {
            childNavCloser.classList.remove('visible');
            navCloser.classList.add('visible');
        }
    });
}

function initTier3Navs() {
    if (!isLargeScreen()) {
        return;
    }
    const tier3NavToggles = document.querySelectorAll('.tier2-nav-item.has-children');

    tier3NavToggles.forEach(toggle => {
        const opener = toggle.querySelector(":scope .child-nav-opener");
        if (!opener) return;

        const targetId = opener.getAttribute("aria-controls");
        const subNav = targetId ? document.getElementById(targetId) : null;
        if (!subNav) return;

        const parentList = toggle.closest("ul.tier2-nav");

        let hideTimeout;

        function showSubnav() {
            // Clear any pending hide
            if (hideTimeout) {
                clearTimeout(hideTimeout);
                hideTimeout = null;
            }

            subNav.style.width = '100%';

            const itemRect = toggle.getBoundingClientRect();
            const subNavWidth = subNav.offsetWidth;
            const spaceRight = window.innerWidth - itemRect.right;

            subNav.classList.remove("visible-right", "visible-left");
            if (parentList) parentList.classList.remove("visible-right", "visible-left");

            if (spaceRight >= subNavWidth) {
                subNav.classList.add("visible-right");
                if (parentList) parentList.classList.add("visible-right");
            } else {
                subNav.classList.add("visible-left");
                if (parentList) parentList.classList.add("visible-left");
            }
        }

        function hideSubnav() {
            subNav.classList.remove("visible-right", "visible-left");
            if (parentList) parentList.classList.remove("visible-right", "visible-left");
        }

        function delayedHide() {
            hideTimeout = setTimeout(hideSubnav, 250); // 150ms delay
        }

        // Show on hover over toggle or submenu
        opener.addEventListener("mouseenter", showSubnav);
        subNav.addEventListener("mouseenter", showSubnav);

        // Hide after short delay when leaving toggle or submenu
        opener.addEventListener("mouseleave", delayedHide);
        subNav.addEventListener("mouseleave", delayedHide);
    });

}

function initTier1Hover() {

    if (!isLargeScreen()) {
        return;
    }

    const navItems = document.querySelectorAll('.tier1-nav-item');
    const navModal = document.getElementById('nav-modal');

    if (!navModal) return;

    navItems.forEach(item => {
        let leaveTimeout; // Store timeout reference

        item.addEventListener('pointerenter', () => {
            if (leaveTimeout) {
                clearTimeout(leaveTimeout);
                leaveTimeout = null;
            }

            if (item.classList.contains('has-children')) {
                navModal.classList.add('visible');
            }
            item.classList.add('hover');
        });

        item.addEventListener('pointerleave', () => {
            leaveTimeout = setTimeout(() => {
                if (item.classList.contains('has-children')) {
                    navModal.classList.remove('visible');
                }
                item.classList.remove('hover');
            }, 50);
        });
    });
}

function isLargeScreen() {
    if (!largeBeacon) return false;

    const style = window.getComputedStyle(largeBeacon);
    return (
        style.display !== "none" &&
        style.visibility !== "hidden" &&
        style.opacity !== "0"
    );
}

function activateDeferredCSS() {
    document.querySelectorAll('link[rel="preload"][as="style"][data-defer-css]')
        .forEach(link => {
            link.rel = "stylesheet";
        });
}

function setupNavScrollListener() {
    window.addEventListener('scroll', function() {
        const verticalScrollPosition = window.scrollY;
        if (verticalScrollPosition > 0) {
            navWrapper.classList.add('scrolling');
        } else {
            navWrapper.classList.remove('scrolling');
        }
    });

    window.dispatchEvent(new Event('scroll'));
}

function initialiseBlur() {
    const blurryTextElements = document.querySelectorAll('.blurry-text');

    const blurryTextElementsObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                let transitionStyle = 'color 1s ease, text-shadow 1s ease, opacity 1s ease';
                entry.target.style.setProperty('transition', transitionStyle, 'important');

                setTimeout(function () {
                    entry.target.style.textShadow = '';
                    entry.target.style.color = '';
                    entry.target.style.opacity = '1';
                }, 200)
                blurryTextElementsObserver.unobserve(entry.target);
            }
        });
    }, {

    });

    blurryTextElements.forEach(element => {

        let textColor = window.getComputedStyle(element).getPropertyValue("color");
        let textShadowStyle = '0 0 15px ' + textColor;
        let colorStyle = 'transparent';
        let opacityStyle = '0.5';

        element.style.setProperty('color', colorStyle, 'important');
        element.style.setProperty('text-shadow', textShadowStyle, 'important');
        element.style.setProperty('opacity', opacityStyle, 'important');

        element.classList.add('blur-setup');

        blurryTextElementsObserver.observe(element);
    });
}


document.addEventListener('DOMContentLoaded', () => {
    initMobileNavBun();
    initNavCloser();
    initMobileNavChildren();
    initTier3Navs();
    initTier1Hover();
    activateDeferredCSS();
    setupNavScrollListener();
    initialiseBlur();
});
